import styled from 'styled-components';

type StyledSliderProps = {
  thumbSize: number;
  trackColor?: string;
};

export const StyledSlider = styled('input')<StyledSliderProps>`
  width: 100%;
  -webkit-appearance: none;
  height: 4px;
  padding: 2px 0;
  background: ${({ theme, trackColor }) => trackColor || theme.color.darkGray};
  border-radius: 5px;
  background-repeat: no-repeat;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: ${({ thumbSize }) => `${thumbSize}px`};
    width: ${({ thumbSize }) => `${thumbSize}px`};
    border-radius: 50%;
    background: ${({ theme }) => theme.color.white};
    transition: background 0.3s ease-in-out;
    cursor: grab;
  }

  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
    cursor: pointer;
  }

  &::-webkit-slider-thumb:hover {
    box-shadow: ${({ theme }) => theme.color.lightGray} 0px 0px 0px 8px;
  }

  &::-webkit-slider-thumb:active {
    box-shadow: ${({ theme }) => theme.color.lightGray} 0px 0px 0px 11px;
    transition:
      box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      left 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;
